import { extractImageUploadIds } from "./imageNodes";

export type ImageReadyState = "processing" | "ready" | "failed" | undefined;

type TextDocumentLike = { text: string };

const parseContent = (text: string): unknown => {
  try {
    return JSON.parse(text);
  } catch {
    return undefined;
  }
};

export const getImageUploadIds = (textDocument: TextDocumentLike): string[] =>
  extractImageUploadIds(parseContent(textDocument.text) as never);

export const getPendingImageUploadIds = (
  textDocument: TextDocumentLike,
  statusByUploadId: Record<string, ImageReadyState>,
): string[] => getImageUploadIds(textDocument).filter((id) => statusByUploadId[id] !== "ready");

export const hasPendingImages = (
  textDocument: TextDocumentLike,
  statusByUploadId: Record<string, ImageReadyState>,
): boolean => getPendingImageUploadIds(textDocument, statusByUploadId).length > 0;
